import classNames from 'classnames';

import { SortDownIcon, SortUpIcon } from '../../icons';

import styles from './_index.module.scss';

export interface SortIndicatorProps {
  direction?: 'asc' | 'desc';
  isActive?: boolean;
  isDisabled?: boolean;
}

const SortIndicator = ({ direction = 'asc', isActive, isDisabled }: SortIndicatorProps) => {
  if (!isActive) return null;

  return (
    <span
      aria-hidden
      className={classNames(styles['sort-indicator'], { [styles['is-disabled']]: isDisabled })}
      data-testid="sort-indicator"
    >
      {direction === 'asc' ? <SortUpIcon /> : <SortDownIcon />}
    </span>
  );
};

export default SortIndicator;
